<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div v-if="open">
    <v-overlay
        z-index="50"
    ></v-overlay>

    <v-navigation-drawer
        absolute class="view"
        permanent
        right
        width="860"
    >
      <!--<v-card>-->
      <v-btn v-if="order.code && this.orders.length > 1" :disabled="this.orders.length < 2" color="primary" fab fixed
             left outlined
             small
             top
             @click="onClickPrevious()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn v-if="order.code && this.orders.length>1" :disabled="this.orders.length < 2" color="primary" fab fixed
             outlined right
             small
             top
             @click="onClickNext()">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      <v-content v-if="activeTab==='Info'">
        <v-card-title v-if="order.code" class="headline">
          {{ order.code }}
          <v-btn :color="OrderConst.color(order.status)" :loading="!order.status" class="headline_status" small tile>
            {{ OrderConst.map(order.status) }}
          </v-btn>
        </v-card-title>

        <!--<v-card-text>Info</v-card-text>-->

        <div class="contents">
          <v-card>
            <v-container class="container--fluid pt-0">
              <v-row>
                <v-col class="clickable" @click="onClickCustomer(order.customer)">

                  รหัสลูกค้า:
                  <TypeBadge v-if="order.customer" :small="true" :type="order.customer.type"></TypeBadge>
                  {{ order.customer && order.customer_code }}

                  <v-btn v-if="!order.code" :color="OrderConst.color(order.status)" class="headline_status" small tile>
                    {{ OrderConst.map(order.status) }}
                  </v-btn>

                  <br/>
                  ชื่อลูกค้า: {{ order.customer && order.customer.nickname }}<br/>

                  ปริมาตร {{ $helper.number_format(order.volume) }}cbm น้ำหนัก {{
                    $helper.number_format(order.weight)
                  }}kg
                  <br/>
                  เงื่อนไข: {{ order.credit_term === 0 ? 'เงินสด' : order.credit_term + ' วัน' }}

                  กลุ่มราคา
                  {{ PromotionGroupConst.map(order.price_group) }}


                  <div v-if="order.invoice_code">
                    แจ้งหนี้ ({{ $helper.date_format_short_with_year(order.invoice_date) }})
                    {{ order.invoice_code }}
                  </div>
                  <div v-if="order.receipt_code">
                    ใบเสร็จ ({{ $helper.date_format_short_with_year(order.receipt_date) }})
                    {{ order.receipt_code }}
                  </div>
                  <div v-if="order.billing_code">
                    บิล {{ order.billing_code }}
                  </div>

                  <div v-if="!is_LoadSubmitOrder && order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE">
                    <CreditBar v-if="order.customer" :border="1"
                               :current="order.customer.debit_amount"
                               :fontSize="14"
                               :height="24"
                               :max="order.customer.credit_amount?order.customer.credit_amount:0"
                               :prop_blue="order.customer.debit_pending"
                               :prop_green="order.customer.debit_invoice"
                               :prop_red="order.customer.debit_overdue"
                               :width="200"
                               class="mt-2"
                    ></CreditBar>
                    <div class="caption mt-0" v-if="order.customer">
                      วงเงิน คงเหลือ
                      {{ $helper.number_format(order.customer.credit_amount - order.customer.debit_amount) }} บาท /
                      {{ order.customer.credit_amount }} บาท
                    </div>
                  </div>

                </v-col>
                <v-col class="col-6">
                  <div>
                    สั่ง ({{ $helper.date_format_short_with_year(order.erp_so_at) }})
                    <span class="pl-2">วันที่อนุมัติ ({{ order.erp_approved_at ? $helper.date_format_short(order.erp_approved_at) : '-' }}) </span>
                  </div>

                  <div v-if="order.do_code">
                    ทริป ({{ $helper.date_format_short_with_year(order.do_date) }})
                    {{ order.do_code }}
                  </div>

                  <div v-if="changingAddress">
                    <v-select
                        v-if="order.customer && order.customer.shipping_addresses"
                        v-model="order.shipping_address_id"
                        :items="order.customer.shipping_addresses.map((address)=>{
                          return {'value':address.id,
                          'text':address.address+' '+(address.district?address.district.name:'')+' '+(address.city?address.city.name:'')+' '+(address.province?address.province.name:'')
                         }})"
                        hide-details
                        label="ที่อยู่"
                        outlined
                        required
                    >
                    </v-select>
                    <v-btn
                        class="float-right ma-2"
                        color="error"
                        fab
                        small
                        @click="changingAddress=false"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        class="float-right ma-2"
                        color="success"
                        fab
                        small
                        @click="saveAddress()"
                    >
                      <v-icon>mdi-check-bold</v-icon>
                    </v-btn>

                  </div>
                  <div v-else>
                    <v-btn
                        v-if="order.status && [
                            OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM,
                            OrderConst.STATUS_SUBMITTED_PENDING_APPROVE,
                            OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO,
                        ].includes(order.status)"
                        :loading="saving_address"
                        class="float-right"
                        color="primary"
                        fab
                        small
                        @click="changeAddress()"
                        style="position: absolute;right: 16px;top: 40px;"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <span v-if="order.shipping_address" class="customer_shipping">
                       ส่ง:
                    {{ order.shipping_address.name }}
                  {{ order.shipping_address.address }}
                  {{ order.shipping_address.district && order.shipping_address.district.name }}
                  {{ order.shipping_address.city && order.shipping_address.city.name }}
                  {{ order.shipping_address.province && order.shipping_address.province.name }}
                  {{ order.shipping_address.zip_code }}
                  </span>
                    <span v-else class="customer_shipping">
                       ส่ง:
                  {{ order.customer && order.customer.address }}<br/>
                  {{ order.customer && order.customer.district }}
                  {{ order.customer && order.customer.province }}
                  {{ order.customer && order.customer.zip_code }}
                  </span>
                  </div>

                  {{ order.do_status == 'success' ? 'ส่งสำเร็จ' : '' }}
                  {{ order.do_status == 'failed' ? 'ส่งไม่สำเร็จ' : '' }}
                  ({{ $helper.date_format_short_with_year(order.do_delivered_at) }})
                  {{ order.do_payment == 'cash' ? '[จ่ายสด/โอน]' : '' }}
                  {{ order.do_payment == 'cash_cb3' ? '[จ่ายสด/โอน CB3%]' : '' }}
                  {{ order.do_payment == 'defer' ? '[โอนตาม]' : '' }}
                  {{ order.do_payment == 'credit' ? '[เครดิต]' : '' }}

                  {{ order.do_comment }}

                  <div>
                    <div class="img-thumbnail clickable" v-for="(media,index) in order.medias">
                      <img :src="media.thumbnail" alt="thumbnail"
                           @click.stop="openImageGallery(order.medias.map(media=>media.content),index)"
                      />
                    </div>


                    <v-file-input
                        class="clickable img-placeholder"
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder=""
                        prepend-icon="mdi-camera"
                        label=""
                        hide-input
                        large
                        @change="onImagePicked"
                    ></v-file-input>

                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <ul class="breadcrumb no-flex" v-if="order.doc_book=='SOOEQ'">
                    <li :class="{'active':order.status==OrderConst.STATUS_CART,'passed':order.status>OrderConst.STATUS_CART}">
                      <a href="#" class="passed">ตะกร้า</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_REJECT}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_REJECT)">ยกเลิก</a></li>
                    <li class="active" v-if="order.status==OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM"><a href="#">รอยืนยัน</a>
                    </li>
                    <li class="active" v-if="order.status==OrderConst.STATUS_SUBMITTED_PENDING_APPROVE"><a href="#">รออนุมัติ</a>
                    </li>
                    <li class="active" v-if="order.status==OrderConst.STATUS_SUBMITTED_PENDING_CUSTOMER"><a href="#">รออนุมัติลูกค้า</a>
                    </li>
                    <li :class="{'active':order.status==OrderConst.STATUS_APPROVED_PENDING_OFM,'passed':order.status>OrderConst.STATUS_APPROVED_PENDING_OFM}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_APPROVED_PENDING_OFM)">ส่ง OFM</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_SYNCED_PENDING_ACTIVE,'passed':order.status>OrderConst.STATUS_SYNCED_PENDING_ACTIVE}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_SYNCED_PENDING_ACTIVE)">บัญชี</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_INVOICED,'passed':order.status>OrderConst.STATUS_INVOICED}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_INVOICED)">แจ้งหนี้</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_PAID,'passed':order.status>OrderConst.STATUS_PAID}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_PAID)">จ่าย</a></li>


                  </ul>

                  <ul class="breadcrumb" v-else>
                    <li :class="{'active':order.status==OrderConst.STATUS_CART,'passed':order.status>OrderConst.STATUS_CART}">
                      <a href="#" class="passed">ตะกร้า</a></li>
                    <li class="active" v-if="order.status==OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM"><a href="#">รอยืนยัน</a>
                    </li>
                    <li class="active" v-if="order.status==OrderConst.STATUS_SUBMITTED_PENDING_APPROVE"><a href="#">รออนุมัติ</a>
                    </li>
                    <li class="active" v-if="order.status==OrderConst.STATUS_SUBMITTED_PENDING_CUSTOMER"><a href="#">รออนุมัติลูกค้า</a>
                    </li>
                    <li :class="{'active':order.status==OrderConst.STATUS_APPROVED_PENDING_SYNC,'passed':order.status>OrderConst.STATUS_APPROVED_PENDING_SYNC}"
                        v-if="order.status==OrderConst.STATUS_APPROVED_PENDING_SYNC">
                      <a href="#">ERP</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_SYNCED_PENDING_ACTIVE,'passed':order.status>OrderConst.STATUS_SYNCED_PENDING_ACTIVE}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_SYNCED_PENDING_ACTIVE)">บัญชี</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO,'passed':order.status>OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_ACCOUNT_CONFIRMED_WAIT_DO)">ทริป</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK,'passed':order.status>OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_DO_CONFIRMED_WAIT_STOCK)">คลัง</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_STOCK_DEBITED_WAIT_START_DELIVERY,'passed':order.status>OrderConst.STATUS_STOCK_DEBITED_WAIT_START_DELIVERY}">
                      <a href="#">ขึ้นรถ</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_DELIVERY_STARTED,'passed':order.status>OrderConst.STATUS_DELIVERY_STARTED}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_DELIVERY_STARTED)">เดินทาง</a></li>

                    <li :class="{'active':[OrderConst.STATUS_DELIVERY_SUCCESS,OrderConst.STATUS_DELIVERY_FAILED].includes(0+order.status),'passed':order.status>OrderConst.STATUS_DELIVERY_FAILED}">
                      <a>
                        {{ `${order.do_status}` == '' ? 'ส่ง' : '' }}
                        {{ `${order.do_status}` == 'null' ? 'ส่ง' : '' }}
                        {{ order.do_status == 'success' ? 'ส่งสำเร็จ' : '' }}
                        {{ order.do_status == 'failed' ? 'ส่งไม่สำเร็จ' : '' }}</a></li>
                    <!--                    <li><a href="#">ส่งไม่ได้</a></li>-->
                    <li :class="{'active':order.status==OrderConst.STATUS_INVOICED,'passed':order.status>OrderConst.STATUS_INVOICED}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_INVOICED)">แจ้งหนี้</a></li>
                    <li :class="{'active':order.status==OrderConst.STATUS_PAID,'passed':order.status>OrderConst.STATUS_PAID}">
                      <a @click="SetOrderStatusForce(OrderConst.STATUS_PAID)">จ่าย</a></li>
                    <!--                    <li><a href="#">ยกเลิก</a></li>-->

                  </ul>

                </v-col>
              </v-row>
              <v-row>
                <v-col style="border-top:1px solid #999">
                  หมายเหตุ:
                  <span
                      v-if="order.customer && order.customer.ship_to && order.comment && order.comment.indexOf(order.customer.ship_to)>-1">
                    {{ order.comment }}
                  </span>
                  <span v-else>
                    {{ order.comment }} {{ order.customer && order.customer.ship_to }}
                  </span>
                  <span v-if="order.credit_term === 0">
                    <br/>{{ order.project }}
                  </span>


                </v-col>
              </v-row>

            </v-container>
          </v-card>
          <!--{{order}}-->

          <v-card
              v-if="isApproveComOptionAble && order.commission_option===OrderUserConst.COM_OPTION_SHIFT_NEXT_REQUEST"
              class="yellow lighten-1">
            <v-container>
              <v-row>
                <v-col>
                  <span class="ml-1 pa-1" style="">
                    เซลล์ขอยกยอดไปเดือนหน้า
                  </span>

                </v-col>
                <v-col v-if="isApproveComOptionAble" class="col-2 text-right">
                  <v-btn :loading="is_ApprovingComOption" class="error" tile @click="RejectShiftNextRequest()">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col v-if="isApproveComOptionAble" class="col-2 text-right">
                  <v-btn :loading="is_ApprovingComOption" class="primary" tile @click="ApproveShiftNextRequest()">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <OrderDialogTablePoint v-if="order.pay_by === 'point'" :order="order" @click-promotion="onClickPromotion" />
          <OrderDialogTableMoney v-else :order="order" @click-promotion="onClickPromotion" />


          <v-footer class="pb-10">
            <v-container>
              <v-row>
                <v-col>
                  เซลล์ <span>เยี่ยมลูกค้า {{ $helper.number_format(order.total_external_discount, 2) }} บาท</span>

                  <!--                  <v-btn v-if="isInOrderSales && order.status > OrderConst.STATUS_CART"-->
                  <!--                         :disabled="isDisableSalesOption"-->
                  <!--                         class="primary float-right"-->
                  <!--                         @click="openSaleCondition()">แก้ไขค่าคอมฯ-->
                  <!--                  </v-btn>-->

                  <v-dialog v-model="isOpenSaleCondition"
                            width="350"
                  >

                    <v-card>
                      <v-card-title>เลือกการคิดค่าคอมฯ
                      </v-card-title>
                      <v-card-text>
                        <v-row>
                          <v-col class="text-center">
                            <v-btn :class="{'primary':com_option===OrderUserConst.COM_OPTION_NORMAL}"
                                   width="100%" @click="com_option=OrderUserConst.COM_OPTION_NORMAL">คิดปกติ
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="text-center">
                            <v-btn :class="{'primary':com_option===OrderUserConst.COM_OPTION_SHIFT_NEXT_REQUEST}"
                                   width="100%" @click="com_option=OrderUserConst.COM_OPTION_SHIFT_NEXT_REQUEST">
                              ขอโอนไปเดือนต่อไป
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="text-center">
                            <v-btn :class="{'primary':com_option===OrderUserConst.COM_OPTION_SKIP_REQUEST}"
                                   width="100%" @click="com_option=OrderUserConst.COM_OPTION_SKIP_REQUEST">
                              ยกให้เซลล์ที่เหลือ
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mr-4" color="gray" text @click="isOpenSaleCondition=false">
                          ยกเลิก
                        </v-btn>
                        <v-btn :loading="isSaveSaleCondition" class="close-button"
                               color="primary"
                               fab tile
                               @click="saveSaleCondition()">
                          ตกลง
                        </v-btn>
                      </v-card-actions>
                    </v-card>

                  </v-dialog>


                  <v-divider class="mb-4"></v-divider>
                  <Avatar v-for="sale in sales" v-bind:key="sale.id" :active="true" :user="sale"></Avatar>

                  <v-avatar

                      v-if="!sales || sales.length===0"
                      color="grey"
                      size="64px"
                  >
                    <v-icon x-large>mdi-plus</v-icon>
                  </v-avatar>
                </v-col>
                <v-col v-if="order.pay_by === 'point'" class="col-4 text-right">
                  <span class="orange--text">
                    <v-icon small color="orange">mdi-star</v-icon>
                    รวมแต้ม: {{ $helper.number_format(order.total_point || 0, 2) }}
                  </span>
                </v-col>
                <v-col v-else class="col-2 text-right">
                  Gross<br/>
                  Vat<br/>
                  Net
                </v-col>
                <v-col v-if="order.pay_by !== 'point'" class="col-2 text-right">
                  {{ $helper.number_format(order.total_gross, 2) }}<br/>
                  {{ $helper.number_format(order.total_vat, 2) }}<br/>
                  {{ $helper.number_format(order.total_net, 2) }}
                </v-col>
              </v-row>

              <v-row v-if="isPriceLessThanLimit">
                <v-col>
                  <span v-if="isPriceLessThanLimit" class="ml-1 red pa-1"
                        style="color: white">
                   ** ราคาต่ำกว่าราคาขายขั้นต่ำ กรุณาติดต่อบัญชี
                  </span>

                </v-col>
              </v-row>
              <v-row v-if="isStockOverLimit">
                <v-col>
                  <span v-if="isStockOverLimit" class="ml-1 red pa-1"
                        style="color: white">
                   ** สินค้าเกินยอด stock
                  </span>

                </v-col>
              </v-row>

              <v-card
                  v-for="sale in sales.filter(sale=>sale.orderUser && (sale.orderUser.com_option===OrderUserConst.COM_OPTION_SKIP_REQUEST))"
                  v-if="isApproveComOptionAble"
                  class="yellow lighten-1">
                <v-container>
                  <v-row>
                    <v-col class="col-8">
                      <span class="ml-1  pa-1">
                        {{ sale.name }} ขอไม่รับค่าคอมฯ
                      </span>

                    </v-col>
                    <v-col v-if="isApproveComOptionAble" class="col-2 text-right">
                      <v-btn :loading="is_ApprovingComOption" class="error" tile
                             @click="RejectSkipRequest(sale.orderUser)">
                        ไม่อนุมัติ
                      </v-btn>
                    </v-col>
                    <v-col v-if="isApproveComOptionAble" class="col-2 text-right">
                      <v-btn :loading="is_ApprovingComOption" class="primary" tile
                             @click="ApproveSkipRequest(sale.orderUser)">
                        อนุมัติ
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>


              <v-row>
                <v-col>
                  <hr/>
                </v-col>
              </v-row>
              <v-row v-for="(post, index) in order.timeline"
                     :key="index"
                     :order="order">
                <v-col>
                  <span style="zoom: 0.6"><Avatar :active="true"
                                                  :user="$store.state.users.id_map[post.user_id]"></Avatar></span>
                  <span class="caption ml-4">{{ $helper.date_format_short_with_year_time(post.created_at) }}</span><br/>

                  <div v-if="post.type==TimelineConst.TYPE_ATTACH && post.content && post.content.attachments">
                    <div class="img-thumbnail-large clickable" v-for="(media,index) in post.content.attachments">
                      <img :src="media.thumbnail"
                           @click.stop="openImageGallery(post.content.attachments.map(media=>media.content),index)"
                      />
                    </div>
                    <span class="ml-4">{{ post.content.text }}</span>
                  </div>

                  <span v-else class="ml-4">{{ post.content }}</span>


                </v-col>
              </v-row>
              <v-row>
                <v-col class="">
                  <v-textarea
                      v-model="user_comment"
                      height="40px"
                      label="Comment"
                      outlined
                  ></v-textarea>
                </v-col>
                <v-col class="col-1" style="max-width: 84px;">
                  <img v-if="this.comment_attach" class="img-thumbnail clickable"
                       :src="this.comment_attach.content"
                  />
                  <v-file-input
                      v-else
                      class="clickable img-placeholder"
                      accept="image/png, image/jpeg, image/bmp"
                      placeholder=""
                      prepend-icon="mdi-camera"
                      label=""
                      hide-input
                      large
                      @change="onImagePickedComment"
                  ></v-file-input>
                </v-col>
                <v-col class="col-2">
                  <v-btn
                      :loading="user_comment_saving"
                      class="primary" @click="postComment()">
                    Send
                  </v-btn>
                </v-col>
              </v-row>


              <v-row v-if="order && order.custom && order.custom.check && order.custom.check.redeem">
                <v-col style="position:relative">
                 <span
                     v-if="order.custom && order.custom.check && order.custom.check.redeem"
                     class="mb-4 red pa-1"
                     style="color: white;">
                    แลกแต้ม
                 </span>
                  <span class="authorized"
                        v-if="order.custom.authorize && order.custom.authorize.redeem && order.custom.authorize.redeem.user">
                     <Avatar
                         v-for="user in $store.state.users.data.filter(u =>{  return order.custom && order.custom.authorize.redeem.user.includes(u.id?u.id:0) })"
                         v-bind:key="user.id" :active="true" :user="user"></Avatar>
                  </span>
                </v-col>
                <v-col v-if="order.custom.approving && order.custom.approving.redeem" class="col-4 text-right">
                  <span :style="{'color':order.custom.approving.redeem.flag?'green':'darkred'}">
                  {{ order.custom.approving.redeem.flag ? 'อนุมัติ' : 'ไม่อนุมัติ' }}({{
                      $helper.date_format_short(order.custom.approving.redeem.at)
                    }})
                  โดย {{ order.custom.approving.redeem.by }}

                    </span>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving || order.custom.approving.redeem==null) && (isApproveAble || (order.custom.authorize && order.custom.authorize.redeem && order.custom.authorize.redeem.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'redeem':false})">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving || order.custom.approving.redeem==null) && (isApproveAble || (order.custom.authorize && order.custom.authorize.redeem && order.custom.authorize.redeem.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'redeem':true})">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>


              <v-row v-if="order && order.custom && order.custom.check && order.custom.check.stock">
                <v-col style="position:relative">
                 <span
                     v-if="order.custom && order.custom.check && order.custom.check.stock"
                     class="mb-4 red pa-1"
                     style="color: white;">
                    เช็คสินค้าคงคลัง
                 </span>
                  <span class="authorized"
                        v-if="order.custom.authorize && order.custom.authorize.stock && order.custom.authorize.stock.user">
                     <Avatar
                         v-for="user in $store.state.users.data.filter(u =>{  return order.custom && order.custom.authorize.stock.user.includes(u.id?u.id:0) })"
                         v-bind:key="user.id" :active="true" :user="user"></Avatar>
                  </span>
                </v-col>
                <v-col v-if="order.custom.approving && order.custom.approving.stock" class="col-4 text-right">
                  <span :style="{'color':order.custom.approving.stock.flag?'green':'darkred'}">
                  {{ order.custom.approving.stock.flag ? 'อนุมัติ' : 'ไม่อนุมัติ' }}({{
                      $helper.date_format_short(order.custom.approving.stock.at)
                    }})
                  โดย {{ order.custom.approving.stock.by }}

                    </span>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving || order.custom.approving.stock==null) && (isApproveAble || (order.custom.authorize && order.custom.authorize.stock && order.custom.authorize.stock.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'stock':false})">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving || order.custom.approving.stock==null) && (isApproveAble || (order.custom.authorize && order.custom.authorize.stock && order.custom.authorize.stock.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'stock':true})">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>
              
              
              <v-row v-if="order && order.custom && order.custom.check && order.custom.check.price2">
                <v-col style="position:relative">
                 <span
                     v-if="order.custom && order.custom.check && order.custom.check.price2"
                     class="mb-4 red pa-1"
                     style="color: white;">
                    ** ราคาต่ำกว่าเกณฑ์
                 </span>
                  <span class="authorized"
                        v-if="order.custom.authorize && order.custom.authorize.price2 && order.custom.authorize.price2.user">
                     <Avatar
                         v-for="user in $store.state.users.data.filter(u =>{  return order.custom && order.custom.authorize.price2.user.includes(u.id?u.id:0) })"
                         v-bind:key="user.id" :active="true" :user="user"></Avatar>
                  </span>
                </v-col>
                <v-col v-if="order.custom.approving && order.custom.approving.price2" class="col-4 text-right">
                  <span :style="{'color':order.custom.approving.price2.flag?'green':'darkred'}">
                  {{ order.custom.approving.price2.flag ? 'อนุมัติราคา' : 'ไม่อนุมัติ' }}({{
                      $helper.date_format_short(order.custom.approving.price2.at)
                    }})
                  โดย {{ order.custom.approving.price2.by }}

                    </span>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving || order.custom.approving.price2==null) && (isApproveAble || (order.custom.authorize && order.custom.authorize.price2 && order.custom.authorize.price2.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'price2':false})">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving || order.custom.approving.price2==null) && (isApproveAble || (order.custom.authorize && order.custom.authorize.price2 && order.custom.authorize.price2.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'price2':true})">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>






              <!--              <v-row v-else-if="order?.custom?.check?.price">-->
              <!--                <v-col>-->
              <!--                 <span-->
              <!--                     v-if="order.custom && order.custom.check && order.custom.check.price"-->
              <!--                     class="mb-4 red pa-1"-->
              <!--                     style="color: white;">-->
              <!--                    ** ราคาต่ำกว่าเกณฑ์-->
              <!--                  </span>-->
              <!--                </v-col>-->
              <!--                <v-col v-if="order.custom.approving?.price" class="col-4 text-right">-->
              <!--                  <span :style="{'color':order.custom.approving.price.flag?'green':'darkred'}">-->
              <!--                  {{ order.custom.approving.price.flag ? 'อนุมัติราคา' : 'ไม่อนุมัติ' }}({{-->
              <!--                      $helper.date_format_short(order.custom.approving.price.at)-->
              <!--                    }})-->
              <!--                  โดย {{ order.custom.approving.price.by }}-->

              <!--                    </span>-->
              <!--                </v-col>-->
              <!--                <v-col-->
              <!--                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && !(order.custom.approving?.price) && isApproveAble"-->
              <!--                    class="col-2 text-right">-->
              <!--                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'price':false})">-->
              <!--                    ไม่อนุมัติ-->
              <!--                  </v-btn>-->
              <!--                </v-col>-->
              <!--                <v-col-->
              <!--                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && !(order.custom.approving?.price) && isApproveAble"-->
              <!--                    class="col-2 text-right">-->
              <!--                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'price':true})">-->
              <!--                    อนุมัติ-->
              <!--                  </v-btn>-->
              <!--                </v-col>-->
              <!--              </v-row>-->

              <v-row v-if="order && order.custom && order.custom.check && order.custom.check.CB3">
                <v-col style="position:relative">
                 <span
                     v-if="order.custom && order.custom.check && order.custom.check.CB3"
                     class="mb-4 red pa-1"
                     style="color: white;">
                    ** มี CB3%
                  </span>
                </v-col>
                <v-col v-if="order.custom.approving && order.custom.approving.CB3" class="col-4 text-right">
                                    <span :style="{'color':order.custom.approving.CB3.flag?'green':'darkred'}">
                  {{ order.custom.approving.CB3.flag ? 'อนุมัติCB3' : 'ไม่อนุมัติ' }}({{
                                        $helper.date_format_short(order.custom.approving.CB3.at)
                                      }})
                  โดย {{ order.custom.approving.CB3.by }}

                    </span>

                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.CB3==null) && (isApproveAble || (order.custom.authorize && order.custom.authorize.CB3 && order.custom.authorize.CB3.user && order.custom.authorize.CB3.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'CB3':false})">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.CB3==null)  && (isApproveAble || (order.custom.authorize && order.custom.authorize.CB3 && order.custom.authorize.CB3.user && order.custom.authorize.CB3.user.includes($store.state.$user.id)))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'CB3':true})">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>


              <v-row v-if="order && order.custom && order.custom.check && order.custom.check.minimum">
                <v-col style="position:relative">
                 <span
                     v-if="order.custom && order.custom.check && order.custom.check.minimum"
                     class="mb-4 red pa-1"
                     style="color: white;">
                    ** ยอดไม่ถึง 3,000
                  </span>
                  <span class="authorized"
                        v-if="order.custom.authorize && order.custom.authorize.minimum && order.custom.authorize.minimum.user">
                     <Avatar
                         v-for="user in $store.state.users.data.filter(u =>{   return order.custom && order.custom.authorize.minimum.user.includes(u.id?u.id:0) })"
                         v-bind:key="user.id" :active="true" :user="user"></Avatar>
                  </span>
                </v-col>
                <v-col v-if="order.custom.approving && order.custom.approving.minimum" class="col-4 text-right">
                                    <span :style="{'color':order.custom.approving.minimum.flag?'green':'darkred'}">
                  {{ order.custom.approving.minimum.flag ? 'อนุมัติยอด' : 'ไม่อนุมัติ' }}({{
                                        $helper.date_format_short(order.custom.approving.minimum.at)
                                      }})
                  โดย {{ order.custom.approving.minimum.by }}

                    </span>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.minimum == null)  && (isApproveAble || order.custom.authorize.minimum.user.includes($store.state.$user.id))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'minimum':false})">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.minimum == null) && (isApproveAble || order.custom.authorize.minimum.user.includes($store.state.$user.id))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'minimum':true})">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>


              <v-row v-if="order && order.custom && order.custom.check && order.custom.check.credit">
                <v-col style="position:relative">
                  <span
                      v-if="order.customer && (order.customer.credit_amount-order.customer.debit_amount-order.total_net<=0)"
                      class="mb-4 red pa-1"
                      style="color: white;">
                   ** สั่งเกินวงเงินไป
                    {{
                      $helper.number_format(-1 * (order.customer.credit_amount - order.customer.debit_amount - order.total_net))
                    }}
                    บาท
                  </span>
                  <span v-else  class="mb-4 green pa-1"
                        style="color: white;">
                    ** วงเงินเกิน(ก่อนหน้านี้) อาจมีการปรับวงเงินระหว่างรออนุมัติ
                  </span>
                  <span class="authorized"
                        v-if="order.custom && order.custom.authorize && order.custom.authorize.credit && order.custom.authorize.credit.user">
                     <Avatar
                         v-if="order.custom.authorize"
                         v-for="user in $store.state.users.data.filter(u =>{  return order.custom && order.custom.authorize.credit.user.includes(u.id?u.id:0) })"
                         v-bind:key="user.id" :active="true" :user="user"></Avatar>
                  </span>
                </v-col>
                <v-col v-if="order.custom.approving && order.custom.approving.credit" class="col-4 text-right">
                   <span :style="{'color':order.custom.approving.credit.flag?'green':'darkred'}">
                  {{ order.custom.approving.credit.flag ? 'อนุมัติวงเงิน' : 'ไม่อนุมัติ' }}({{
                       $helper.date_format_short(order.custom.approving.credit.at)
                     }})
                  โดย {{ order.custom.approving.credit.by }}

                    </span>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.credit==null) && (isApproveAble || order.custom.authorize.credit.user.includes($store.state.$user.id))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'credit':false})">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.credit==null) && (isApproveAble || order.custom.authorize.credit.user.includes($store.state.$user.id))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'credit':true})">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>


              <v-row v-if="order && order.custom && order.custom.check && order.custom.check.invoices">
                <v-col style="position:relative">
                  <span
                      v-if="order.custom && order.custom.check && order.custom.check.invoices && order.custom.check.invoices.length>0"
                      class="mb-4 red pa-1"
                      style="color: white;">
                    ** ลูกหนี้ค้างจ่าย <br/>
                    <span v-for="(item,index) in order.custom.check.invoices" :key="index" style="font-size: 0.8em">
                      {{ item.code }} [{{ OrderConst.map(item.status) }}] : {{ item.total_net }} บาท
                      {{ item.invoice_code ? '(' + item.invoice_code + ')' : '' }}
                      {{ item.invoice_date ? $helper.date_format_short_with_year(item.invoice_date) : '' }}

                      <br/>
                    </span>

                  </span>
                  <span class="authorized"
                        v-if="order.custom && order.custom.authorize && order.custom.authorize.invoices && order.custom.authorize.invoices.user">
                     <Avatar
                         v-for="user in $store.state.users.data.filter(u => order.custom && order.custom.authorize.invoices.user.includes(u.id?u.id:0))"
                         v-bind:key="user.id" :active="true" :user="user"></Avatar>
                  </span>
                </v-col>
                <v-col v-if="order.custom.approving && order.custom.approving.invoices" class="col-4 text-right">
                                     <span :style="{'color':order.custom.approving.invoices.flag?'green':'darkred'}">
                  {{ order.custom.approving.invoices.flag ? 'อนุมัติค้างจ่าย' : 'ไม่อนุมัติ' }}({{
                                         $helper.date_format_short(order.custom.approving.invoices.at)
                                       }})
                  โดย {{ order.custom.approving.invoices.by }}

                    </span>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.invoices==null) && (isApproveAble || order.custom.authorize.invoices.user.includes($store.state.$user.id))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="error" tile @click="ApprovingOrder({'invoices':false})">
                    ไม่อนุมัติ
                  </v-btn>
                </v-col>
                <v-col
                    v-if="(order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) && (order.custom.approving==null || order.custom.approving.invoices==null) && (isApproveAble || order.custom.authorize.invoices.user.includes($store.state.$user.id))"
                    class="col-2 text-right">
                  <v-btn :loading="is_LoadSubmitOrder" class="primary" tile @click="ApprovingOrder({'invoices':true})">
                    อนุมัติ
                  </v-btn>
                </v-col>
              </v-row>

              <v-row v-if="$store.state.$user.role===UserConst.ROLE_ADMIN">
                <v-col>
                  <hr/>
                </v-col>
              </v-row>
              <v-row v-if="$store.state.$user.role===UserConst.ROLE_ADMIN">
                <v-col class=" text-right">
                  <a :href="'/api/orders/'+order.id+'/log?token='+$helper.access_token()"
                     style="text-decoration: none" target="_blank">
                    <v-btn class="ma-2">Log
                    </v-btn>
                  </a>
                </v-col>
              </v-row>

            </v-container>
          </v-footer>
        </div>
      </v-content>


      <v-content v-if="activeTab==='Timeline'">
        <v-card-title class="headline">{{ order.code }}</v-card-title>
        <v-card-text>Timeline</v-card-text>


      </v-content>

      <v-content v-if="activeTab==='Quotation'">
        <iframe :src="quotationUrl" class="quotation_iframe"></iframe>
      </v-content>


      <v-app-bar bottom fixed height="60">
        <!--<v-footer bottom>-->
        <!--<template v-slot:default>-->
        <v-tabs
            v-model="active_tab"
            bottom
            center-active
            centered
            fixed
            height="60"
            slider-color="slider"
            slider-size="5"
        >


          <TabForDialog v-for="(tab, index) in tabs" :key="index" :tab="tab"></TabForDialog>

        </v-tabs>
        <!--</template>-->
      </v-app-bar>


      <v-dialog v-model="is_open_quotation"
                width="350"
      >

        <v-card>
          <v-card-title>เลือกชนิดใบเสนอราคา
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="text-center">
                <v-btn class="primary"
                       width="100%"
                       @click="generateQuotation(true)">ลงวันที่
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn class="primary"
                       width="100%"
                       @click="generateQuotation(false)">ไม่ลงวันที่
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="gray" text @click="is_open_quotation=false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-dialog>


      <v-dialog v-model="is_open_customer_order"
                width="350"
      >

        <v-card>
          <v-card-title>ใบสั่งซื้อสำหรับลูกค้า
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col class="text-center">
                <v-text-field
                    :value="`https://${window.location.host}/orders/customer_order/${order.id}`"
                    @focus="$event.target.select()">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <a :href="`/orders/customer_order/${order.id}`" target="_blank">
                  <v-btn class="primary"
                         width="100%">
                    เปิด
                  </v-btn>
                </a>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="gray" text @click="is_open_customer_order=false">
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-dialog>


      <v-btn
          v-if="(currentState==='staging' || currentState==='local' ) && !tabs_quotation.isAdded && (order.status===OrderConst.STATUS_CART || order.status===OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM)"
          :loading="is_LoadSubmitOrder" bottom class="close-button primary" fixed float right
          style="margin-right: 352px;bottom: 18px"
          tiled
          x-large
          @click="CustomerOrder"
      >
        ใบสั่งซื้อ
      </v-btn>


      <v-btn
          v-if="!tabs_quotation.isAdded && (order.status===OrderConst.STATUS_CART || order.status===OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM)"
          :loading="is_LoadSubmitOrder" bottom class="close-button primary" fixed float right
          style="margin-right: 200px;bottom: 18px"
          tiled
          x-large
          @click="Quotation()"
      >
        ใบเสนอราคา
      </v-btn>

      <v-btn
          v-if="(order.status===OrderConst.STATUS_CART || order.status===OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM)"
          :loading="is_LoadSubmitOrder" bottom class="close-button success" fixed float right
          style="margin-right: 100px;bottom: 18px"
          tiled
          x-large
          @click="ConfirmOrder()"

      >

        ยืนยัน
      </v-btn>


      <v-btn v-if="order.status===OrderConst.STATUS_REJECT" :loading="is_LoadSubmitOrder" bottom
             class="close-button success" fixed float right
             style="margin-right: 100px;bottom: 18px"
             tiled
             x-large
             @click="ReCartOrder()">
        สร้างใหม่
      </v-btn>

      <v-btn :loading="is_LoadSubmitOrder" bottom class="close-button" color="primary" fab fixed float
             right
             @click="()=>{this.close()}">
        <v-icon>mdi-close</v-icon>
      </v-btn>


      <v-btn
          v-if="
                order.doc_book==='SOOEQ' ||
                (order.code?.startsWith('PENDING') && order.status===OrderConst.STATUS_SYNCED_PENDING_ACTIVE) ||
                (order.code?.startsWith('PENDING') && order.status===OrderConst.STATUS_SUBMITTED_PENDING_APPROVE) ||
                order.status===OrderConst.STATUS_APPROVED_PENDING_SYNC ||
                order.status===OrderConst.STATUS_APPROVED_PENDING_OFM ||
                order.status===OrderConst.STATUS_SUBMITTED_PENDING_CONFIRM ||
                order.status===OrderConst.STATUS_SUBMITTED_PENDING_CUSTOMER ||
                order.status===OrderConst.STATUS_REJECT
              "
          :loading="is_LoadSubmitOrder" bottom class="delete-button" color="error" fab fixed float
          left
          style="z-index: 5"
          @click="deletingObject(order)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>


      <!--</v-card>-->
      <!--</v-dialog>-->
    </v-navigation-drawer>

  </div>
</template>
<style lang="scss" scoped>
.contents {
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_iframe {
  width: 100%;
  border: 0;
  height: calc(100vh - 80px);
  overflow: auto;
}

.quotation_share {
  margin-bottom: 90px;
}

.headline {
  padding-top: 20px;
  padding-bottom: 0;
  height: 56px;
}

.headline_status {
  margin-left: 10px;
}

.overlay {
  z-index: 50 !important;
}

.view {
  z-index: 60 !important;

  .v-card__title {
    padding-left: 68px;
    padding-right: 68px;
  }

  .v-app-bar {
    padding-right: 96px;
  }
}

.customer_shipping {
  border: dashed 1px #999;
  display: inline-block;
  width: 100%;
  padding: 0 8px;
  background: #CCC;
  min-height: 48px;
}

.img-thumbnail {
  margin: 0 2px 2px 0;
  display: inline-block;
  width: 60px;
  height: 60px;

  img {
    width: 60px;
    height: fit-content;
    margin: 0;
    border: solid 1px #ccc;
  }
}

.img-thumbnail-large {
  margin: 0 2px 2px 0;
  display: inline-block;
  width: 190px;
  height: 60px;

  img {
    width: 190px;
    height: fit-content;
    margin: 0;
    border: solid 1px #ccc;
  }
}


.item-qty {
  min-width: 80px;
}

.list-container {
  .list-row {
    position: relative;
    height: auto;
    margin-left: 0;
  }

  .list-row {
    font-size: 20px;
  }

  @media all and (max-width: 599px) {
    .list-row {
      font-size: 16px;
    }
  }
  @media all and (min-width: 600px) and (max-width: 720px) {
    .list-row {
      font-size: 18px;
    }
  }
  @media all and (min-width: 720px) and (max-width: 960px) {
    .list-row {
      font-size: 20px;
    }
  }
}

.itemTable {

  line-height: 1.2;
}

.ItemHead {
  th {
    font-size: 16px;
  }
}

.ItemRow {
  td {
    font-size: 16px;
    padding: 0 4px;
  }

  td:first-child {
    font-size: 16px;
    padding-left: 8px;
  }

  td:last-child {
    padding-right: 8px;
  }

}

.authorized {
  zoom: 0.6;
  position: absolute;
  right: 0;
  top: 20px;
}

.breadcrumb {
  list-style: none;
  overflow: hidden;
  //font: 18px Helvetica, Arial, Sans-Serif;
  margin: 0;
  padding: 0;
  padding-inline: 0;
  margin-block: 0;
  //zoom: 0.8;
  font-size: 0.8em;
  display: flex;
}

.breadcrumb.no-flex {
  display: block;
}

.breadcrumb li {
  float: left;
  flex: auto;
}

.breadcrumb li a {
  //color: gray;
  color: white;
  text-decoration: none;
  padding: 8px 0 8px 45px;
  background: #b2b2b2; /* fallback color */
  //background: hsla(34,85%,35%,1);
  position: relative;
  display: block;
  float: left;
}

.breadcrumb li a:after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent; /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  border-left: 30px solid #b2b2b2;
  //border-left: 30px solid hsla(34,85%,35%,1);
  position: absolute;
  top: 50%;
  margin-top: -50px;
  left: 100%;
  z-index: 2;
}


.breadcrumb li a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-top: 50px solid transparent; /* Go big on the size, and let overflow hide */
  border-bottom: 50px solid transparent;
  border-left: 30px solid white;
  position: absolute;
  top: 50%;
  margin-top: -50px;
  margin-left: 6px;
  left: 100%;
  z-index: 1;
}

.breadcrumb li:first-child a {
  padding-left: 10px;
}

.breadcrumb li.passed a:after {
  border-left: 30px solid #468bff
}

.breadcrumb li.passed a {
  background: #468bff
}

.breadcrumb li.active a:after {
  border-left: 30px solid #0753d1;
}

.breadcrumb li.active a {
  background: #0753d1;
}

//.breadcrumb li:nth-child(2) a       { background:        hsla(34,85%,45%,1); }
//.breadcrumb li:nth-child(2) a:after { border-left-color: hsla(34,85%,45%,1); }
//.breadcrumb li:nth-child(3) a       { background:        hsla(34,85%,55%,1); }
//.breadcrumb li:nth-child(3) a:after { border-left-color: hsla(34,85%,55%,1); }
//.breadcrumb li:nth-child(4) a       { background:        hsla(34,85%,65%,1); }
//.breadcrumb li:nth-child(4) a:after { border-left-color: hsla(34,85%,65%,1); }
//.breadcrumb li:nth-child(5) a       { background:        hsla(34,85%,75%,1); }
//.breadcrumb li:nth-child(5) a:after { border-left-color: hsla(34,85%,75%,1); }
//.breadcrumb li:last-child a {
//  background: transparent !important;
//  color: black;
//  pointer-events: none;
//  cursor: default;
//}
//.breadcrumb li:last-child a:after { border: 0; }
.breadcrumb li a:hover {
  background: #0000FF;
}

.breadcrumb li a:hover:after {
  border-left: 30px solid #0000FF;
}

.breadcrumb li:last-child {
}

.breadcrumb li:last-child a:before {
  content: none;
}

.breadcrumb li:last-child a:after {
  content: none;
}

.breadcrumb li:last-child a {
  padding-right: 40px;
  margin-right: -20px;
}

//
//.breadcrumb li a:hover:after {
//  background: #0000FF;
//}


</style>
<script lang="ts">


import {Customer} from '@/models/Customer'
import {Item} from '@/models/Item'
import {Media} from '@/models/Media'
import {SimpleResponse} from '@/models/Model'
import {DataOrder, Order, OrderConst} from '@/models/Order'
import {OrderUser, OrderUserConst} from '@/models/OrderUser'
import {PromotionGroupConst} from '@/models/Promotion'
import {Timeline, TimelineConst} from '@/models/Timeline'
import {User, UserConst} from '@/models/User'
import md5 from 'md5'
import {Component, Vue} from 'vue-property-decorator'
import CreditBar from '../components/Customer/CreditBar.vue'
import TypeBadge from '../components/Customer/TypeBadge.vue'
import ItemRow from '../components/Order/ItemRow.vue'
import StatusBadge from '../components/Order/StatusBadge.vue'
import TabForDialog from '../components/TabForDialog.vue'
import Avatar from '../components/User/Avatar.vue'
import OrderDialogTableMoney from '../components/OrderDialog/OrderDialogTableMoney.vue'
import OrderDialogTablePoint from '../components/OrderDialog/OrderDialogTablePoint.vue'
import router from '../router'
import Helper from '../services/Helper.js'

@Component({
  computed: {
    User() {
      return User
    }
  },
  components: {Avatar, TypeBadge, TabForDialog, ItemRow, CreditBar, StatusBadge, OrderDialogTableMoney, OrderDialogTablePoint}
})
export default class OrderDialog extends Vue {
  UserConst = UserConst
  TimelineConst = TimelineConst
  PromotionGroupConst = PromotionGroupConst
  open = false

  window = window

  isOpenSaleCondition = false
  isSaveSaleCondition = false

  md5 = md5

  OrderUserConst = OrderUserConst

  com_option = OrderUserConst.COM_OPTION_NORMAL
  index = 0
  orders: Order[] = []
  activeTab: string = 'Info'
  OrderConst = OrderConst

  active_tab = 0

  tabs_info = {
    key: 'info',
    name: 'ข้อมูล',
    click: () => this.click_tab('Info'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0
  }
  tabs_quotation = {
    key: 'quotation',
    name: 'ใบเสนอราคา',
    click: () => this.click_tab('Quotation'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: false,
    badge_number: 0,
    isAdded: false
  }
  tabs_timeline = {
    name: 'Timeline',
    click: () => this.click_tab('Timeline'),
    path: null,
    permissions: [],
    isLoad: false,
    badge: true,
    badge_number: 5
  }
  tabs: any = [
    // this.tabs_info,
  ]
  dialog: boolean = false
  user_comment: string = ''
  user_comment_saving: boolean = false
  order: Order = new Order()
  isLoadOrder = false
  is_LoadSubmitOrder = false
  is_ApprovingComOption = false
  sales: User[] = []
  isPriceLessThanLimit = false
  isStockOverLimit = false
  is_open_quotation: boolean = false
  is_open_customer_order: boolean = false
  quotationUrl = ''
  changingAddress = false
  saving_address = false

  get isInOrderSales() {
    const user_code = this.$store.state.$user.employee_code
    return this.sales.filter(user => user.employee_code == user_code).length > 0
  }

  get isDisableSalesOption() {
    const user_code = this.$store.state.$user.employee_code
    const current_sale = this.sales.filter(user => user.employee_code == user_code)
    if (current_sale.length == 1) {
      // debugger
      return current_sale[0].orderUser &&
          (
              current_sale[0].orderUser.com_option == OrderUserConst.COM_OPTION_SHIFT_NEXT ||
              current_sale[0].orderUser.com_option == OrderUserConst.COM_OPTION_SKIP ||
              current_sale[0].orderUser.com_option == OrderUserConst.COM_OPTION_TIER2
          )
    }

    return false
  }

  get isApproveComOptionAble() {
    switch (this.$store.state.$user.role) {
      case UserConst.ROLE_ADMIN:
        return true
      case UserConst.ROLE_CEO:
        return true
      case UserConst.ROLE_DIRECTOR:
        return true
      default:
        return false
    }


  }

  get isApproveAble() {
    switch (this.$store.state.$user.role) {
      case UserConst.ROLE_ADMIN:
        return true
        // case UserConst.ROLE_CEO:
        //   return true
        // case UserConst.ROLE_DIRECTOR:
        //   return true
        // case UserConst.ROLE_MANAGER:
        //   return true
        // case UserConst.ROLE_ACCOUNT:
        //   return true
      default:
        return false
    }


  }

  get currentState() {
    return process.env.VUE_APP_STATE
  }

  onApply: Function = () => {

  }

  openSaleCondition() {

    this.isOpenSaleCondition = true
  }

  async saveSaleCondition() {
    this.isSaveSaleCondition = true

    await this.doSaveSaleCondition(this.com_option)

    this.isSaveSaleCondition = false
    this.isOpenSaleCondition = false
  }

  async doSaveSaleCondition(com_option: number) {

    let order: Order = new Order()
    order.id = this.order.id
    order.mode = 'com_option'
    if (!order.hasOwnProperty('SetTmpComOption')) {
      order = Object.setPrototypeOf(order, Order.prototype)
    }
    this.is_LoadSubmitOrder = true
    // debugger
    try {
      order = await order.SetTmpComOption(com_option)
      this.order = order
      this.refreshSale()
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitOrder = false
  }

  onOpen({id, order, orders, index, debug, skip_load, onApply}) {
    if (this.open) return
    console.log('Emited', {order, orders, index, debug})

    this.tabs_quotation.isAdded = false
    this.tabs = this.tabs.filter(tab => tab.key != 'quotation')
    this.activeTab = 'Info'
    this.active_tab = 0


    this.order = new Order()
    if (order) {
      this.order = order
    } else if (id) {
      this.order.id = id
    }
    if (index && orders) {
      this.index = index
      this.orders = orders
    } else {
      this.index = 0
      this.orders = []
    }
    if (this.order.customer === null) {
      this.order.customer = new Customer()
    }
    this.open = true
    this.sales = []
    if (skip_load) {
      this.refreshSale()
      this.refreshItems()
    } else {
      this.getOrder()
    }
    this.onApply = onApply
  }

  mounted() {
    this.$root.$on('openOrder', this.onOpen)
  }

  onClickPrevious() {
    if (this.orders.length > 1) {
      var index = (this.index - 1) % this.orders.length
      if (this.orders[index]) {
        this.index = index
        this.order = this.orders[this.index]
        this.getOrder()
      }
    }
  }

  onClickNext() {
    if (this.orders.length > 1) {
      var index = (this.index + 1) % this.orders.length
      if (this.orders[index]) {
        this.index = index
        this.order = this.orders[this.index]
        this.getOrder()
      }
    }
  }

  click_tab(name: string): void {
    if (name === 'Cart') {
      this.close()
      router.push('/cart')
    } else {
      this.activeTab = name
    }

  }

  async postComment() {
    this.user_comment_saving = true
    let timeline = new Timeline()
    timeline.created_at = new Date()
    timeline.order_id = this.order.id
    timeline.user_id = this.$store.state.$user.id

    if (this.comment_attach) {
      timeline.type = TimelineConst.TYPE_ATTACH
      let media = this.comment_attach
      media = await media.save()
      const content = {
        text: this.user_comment,
        attachments: [
          media
        ]
      }
      timeline.type = TimelineConst.TYPE_ATTACH
      timeline.content = JSON.stringify(content)
    } else {

      timeline.type = TimelineConst.TYPE_COMMENT
      timeline.content = this.user_comment
    }


    try {
      timeline = await timeline.save()
      this.order.timeline.push(timeline)

      this.user_comment = ''
      this.comment_attach = null
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.user_comment_saving = false

  }

  async doPostComment(type, content) {
    this.user_comment_saving = true
    let timeline = new Timeline()
    timeline.created_at = new Date()
    timeline.order_id = this.order.id
    timeline.user_id = this.$store.state.$user.id
    timeline.type = type
    timeline.content = content
    try {
      timeline = await timeline.save()
      this.order.timeline.push(timeline)
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.user_comment_saving = false

  }

  getOrder() {
    const id = this.order.id
    this.tabs_info.isLoad = true
    Helper.get(Helper.setting.order.getResourceAPI.replace('{id}', id))
        .then<{ data: DataOrder }>(({data}) => {

          console.log('getOrder', data.data)
          this.order = data.data
          Order.cart_validate(this.order)

          this.refreshSale()
          this.refreshItems()


          // this.items = data.data

          //this.$store.commit('orders_response', data)
          //this.reloadItem()
          this.tabs_info.isLoad = false
        }).catch(error => {
      if (error && error.response && error.response.status == 404) {
        this.$root.$emit('onError', {message: 'ไม่พบออร์เดอร์', error: error})
        this.close()
      } else {
        this.$root.$emit('onError', {error: error})
      }
    })

  }

  refreshItems() {
    console.log('refreshItems')

    /*//Price less than limit
    this.isPriceLessThanLimit = false
    if (this.order) {
      for (let i in this.order.items) {
        const item = this.order.items[i]
        if (item.price_final == 0 || item.price_final === null) continue
        if (item.price_init == 0 || item.price_init === null) continue

        // console.log('item', item.price_final < item.price_init)
        this.isPriceLessThanLimit = this.isPriceLessThanLimit || item.price_final < item.price_init
      }
    }
    console.log('isPriceLessThanLimit', this.isPriceLessThanLimit)*/

    //Stock Over Limit
    // this.isStockOverLimit = false
    // if (this.order) {
    //   for (let i in this.order.items) {
    //     const item = this.order.items[i]
    //     if (item.product && item.product.non_over_stock && item.quantity) {
    //       // console.log('item', item.price_final < item.price_init)
    //       let isStockOverLimit = this.isStockOverLimit || item.product.stock_MT == 0 || (item.product.stock_MT && item.quantity > item.product.stock_MT)
    //       if (isStockOverLimit !== null)
    //         this.isStockOverLimit = isStockOverLimit
    //     }
    //   }
    // }
    // console.log('isStockOverLimit', this.isStockOverLimit)


  }

  async ApproveOrder() {
    await this.SetOrderStatus(OrderConst.STATUS_APPROVED_PENDING_SYNC)
  }

  async RejectOrder() {
    await this.SetOrderStatus(OrderConst.STATUS_REJECT)
  }

  async CancelOrder() {
    await this.SetOrderStatus(OrderConst.STATUS_CART)
    this.close()
  }

  async ApproveShiftNextRequest() {
    this.doSaveCondition(OrderUserConst.COM_OPTION_SHIFT_NEXT)
  }

  async RejectShiftNextRequest() {
    this.doSaveCondition(OrderUserConst.COM_OPTION_NORMAL)
  }

  async doSaveCondition(com_option: number) {

    let order: Order = new Order()
    order.id = this.order.id
    order.mode = 'commission_option'
    if (!order.hasOwnProperty('SetComOption')) {
      order = Object.setPrototypeOf(order, Order.prototype)
    }

    this.is_ApprovingComOption = true

    // debugger
    try {
      order = await order.SetComOption(com_option)
      this.order = order
      this.refreshSale()
    } catch (e) {
      // alert(e);
    }
    this.is_ApprovingComOption = false
  }

  async ApproveSkipRequest(orderUser) {
    this.doSaveOrderUserCondition(orderUser, OrderUserConst.COM_OPTION_SKIP)
  }

  async RejectSkipRequest(orderUser) {
    this.doSaveOrderUserCondition(orderUser, OrderUserConst.COM_OPTION_NORMAL)
  }

  async doSaveOrderUserCondition(oUser: OrderUser, com_option: number) {

    let orderUser: OrderUser = new OrderUser()
    orderUser.id = oUser.id
    if (!orderUser.hasOwnProperty('Save')) {
      orderUser = Object.setPrototypeOf(orderUser, OrderUser.prototype)
    }
    this.is_ApprovingComOption = true
    // debugger
    try {
      orderUser.com_option = com_option
      console.log(orderUser)
      await orderUser.save()
      oUser.com_option = com_option
      this.getOrder()
    } catch (e) {
      // alert(e);
    }
    this.is_ApprovingComOption = false
  }

  async Quotation() {

    if (this.isPriceLessThanLimit) {
      this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
      return
    }

    if (this.isStockOverLimit) {
      this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
      return
    }

    let order: Order = this.order

    if (!order.hasOwnProperty('save')) {
      order = Object.setPrototypeOf(order, Order.prototype)
    }
    this.is_LoadSubmitOrder = true
    // debugger
    try {
      await order.save<Order>()
      this.is_open_quotation = true
    } catch (e) {
      this.$root.$emit('onError', {error: e})

    }
    this.is_LoadSubmitOrder = false
  }

  async CustomerOrder() {

    if (this.isPriceLessThanLimit) {
      this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
      return
    }

    if (this.isStockOverLimit) {
      this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
      return
    }

    let order: Order = this.order

    if (!order.hasOwnProperty('save')) {
      order = Object.setPrototypeOf(order, Order.prototype)
    }
    this.is_LoadSubmitOrder = true
    // debugger
    try {
      await order.save<Order>()
      this.is_open_customer_order = true
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.is_LoadSubmitOrder = false
  }

  async ConfirmOrder() {
    if (this.isPriceLessThanLimit) {
      this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
      return
    }

    if (this.isStockOverLimit) {
      this.$root.$emit('onError', {message: 'ยืนยันไม่สำเร็จ รายการสินค้าบางรายการ ไม่ผ่านเงื่อนไขการขาย'})
      return
    }

    let order: Order = this.order

    if (!order.hasOwnProperty('SubmitCart')) {
      order = Object.setPrototypeOf(order, Order.prototype)
    }
    this.is_LoadSubmitOrder = true
    // debugger
    try {
      order = await order.SubmitCart()
      this.$store.commit('carts_remove', order)
      console.log(this.onApply)
      this.onApply && this.onApply()
      this.close()

      this.$root.$emit('onSuccess', {message: 'ส่งออเดอร์เรียบร้อย'})
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitOrder = false
  }

  async onClickCustomer(customer: Customer | null) {
    this.close()
    this.$root.$emit('openCustomer', {customer: customer})
  }

  async onClickPromotion(item: Item) {
    //console.log(item)
    this.$root.$emit('openPromotion', {id: item.promotion_id})
  }

  async saveAddress() {
    this.saving_address = true
    //console.log(this.order.shipping_address_id)
    this.changingAddress = false

    if (this.order.customer && this.order.customer.shipping_addresses && this.order.shipping_address_id) {
      let shipping_addresses = this.order.customer.shipping_addresses.filter(address => address.id == this.order.shipping_address_id)[0]
      if (shipping_addresses) {
        this.order.shipping_address = shipping_addresses

        let order: Order = new Order()
        order.id = this.order.id
        order.mode = 'address'
        if (!order.hasOwnProperty('SetAddress')) {
          order = Object.setPrototypeOf(order, Order.prototype)
        }
        try {
          order = await order.SetAddress(this.order.shipping_address_id)
          //this.order = order
        } catch (e) {
          // alert(e);
        }

      }
    }
    this.saving_address = false

  }

  async changeAddress() {
    let order: Order = this.order
    if (order.customer) {
      let customer: Customer = order.customer
      if (customer.shipping_addresses && customer.shipping_addresses.length > 1) {
        //Choose address
        this.changingAddress = true
      } else {
        this.close()
        this.$root.$emit('openCustomer', {customer: customer, activeTab: 'Address'})
      }
    }
  }


  async ReCartOrder() {
    this.is_LoadSubmitOrder = true
    await this.$store.dispatch('load_carts')
    await this.SetOrderStatus(OrderConst.STATUS_CART)

    // Set project_cb3 to true if order.project is 'CB3%'
    if (this.order.project === 'CB3%') {
      this.order.project_cb3 = true
    }

    this.$store.commit('carts_append', this.order)
    this.close()
    router.push('/cart')
  }

  close() {
    this.open = false
  }

  async ApprovingOrder(type: any) {
    let order: Order = new Order()
    order.id = this.order.id
    this.is_LoadSubmitOrder = true
    // debugger
    try {
      order = await Helper.post(Helper.setting.order.approvingAPI.replace('{id}', order.id), {
        'approving': type
      })
          .then<{ data: DataOrder }>(({data}): Order => data.data)
      this.order = order
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitOrder = false
    return order
  }

  async SetOrderStatusForce(status: number) {
    if (this.order.status == status) return
    if (this.$store.state.$user.role != UserConst.ROLE_ADMIN) return
    if (this.order.doc_book != 'SOOEQ' && !(confirm('ยืนยันตั้งสถานะใหม่?'))) return
    let order: Order = new Order()
    order.id = this.order.id
    order.mode = 'status'
    if (!order.hasOwnProperty('SetStatus')) {
      order = Object.setPrototypeOf(order, Order.prototype)
    }
    this.is_LoadSubmitOrder = true
    // debugger
    try {
      order = await order.SetStatus(status)
      this.order = order
      this.$root.$emit('onSuccess', {message: 'บันทึกสำเร็จ'})
    } catch (e) {
      this.$root.$emit('onError', {error: e})
    }
    this.is_LoadSubmitOrder = false
    return order
  }

  async SetOrderStatus(status: number) {
    if (this.order.status == status) return
    let order: Order = new Order()
    order.id = this.order.id
    order.mode = 'status'
    if (!order.hasOwnProperty('SetStatus')) {
      order = Object.setPrototypeOf(order, Order.prototype)
    }
    this.is_LoadSubmitOrder = true
    // debugger
    try {
      order = await order.SetStatus(status)
      this.order = order
    } catch (e) {
      // alert(e);
    }
    this.is_LoadSubmitOrder = false
    return order
  }

  async deletingObject(order: Order) {
    this.$confirm('ยืนยันลบข้อมูล?').then(res => {
      if (res) {
        this.deleteObject(order)
        this.close()
      } else {

      }
    })

  }

  async deleteObject(order: Order) {
    // this.is_LoadSubmitOrder = true
    try {
      if (!order.hasOwnProperty('delete')) {
        order = Object.setPrototypeOf(order, Order.prototype)
      }
      const response: SimpleResponse = await order.delete()

      this.orders = this.orders.filter(object => object.id != this.order?.id)

      if (response.data.success) {
        this.$root.$emit('onSuccess', {message: response.toString()})
      } else {
        this.$root.$emit('onError', {message: response.toString()})
      }


    } catch (e) {
      console.log(e)
      this.$root.$emit('onError', {error: e})
    }

  }

  generateQuotation(has_date: boolean) {

    if (has_date) {
      this.quotationUrl = '/api/quotation/' + this.order.id + '/date/' + md5('spa_date' + this.order.id) + '?share=LINE'
    } else {
      this.quotationUrl = '/api/quotation/' + this.order.id + '/no_date/' + md5('spa_no_date' + this.order.id) + '?share=LINE'
    }
    this.tabs_quotation.isAdded = true
    this.tabs.push(this.tabs_quotation)
    this.activeTab = 'Quotation'
    this.active_tab = 1
    this.is_open_quotation = false
    this.is_open_customer_order = false
  }

  share(order: Order) {

  }

  private refreshSale() {
    this.sales = []
    console.log('order sales', this.order.sales)
    for (let index in this.order.sales) {
      let sale = this.order.sales[index]
      if (!sale || !sale.user_code) continue
      console.log('sales', sale)

      if (sale.com_option !== null && this.$store.state.$user.employee_code == sale.user_code) {
        this.com_option = sale.com_option
      }

      if (this.$store.state.users.code_map.hasOwnProperty(sale.user_code)) {
        let user = JSON.parse(JSON.stringify(this.$store.state.users.code_map[sale.user_code]))
        user.orderUser = sale
        this.sales.push(user)
      } else {
        let sale2 = new User()
        sale2.department = '??'
        sale2.nickname = sale.user_code
        sale2.picture = null
        sale2.orderUser = sale
        this.sales.push(sale2)
      }
    }
  }

  private async openImageGallery(imageList, index) {
    this.$root.$emit('openImageGallery', {
      imageList: imageList,
      imageIndex: index
    })
  }

  comment_attach: null | Media = null

  onImagePickedComment(e) {

    const fr = new FileReader()
    fr.readAsDataURL(e)
    fr.addEventListener('load', () => {
      let media = new Media(fr.result)
      media.attachable_id = this.order.id
      media.attachable_type = 'App\\Models\\Order'

      this.comment_attach = media

    })
  }

  onImagePicked(e) {

    const fr = new FileReader()
    fr.readAsDataURL(e)
    fr.addEventListener('load', async () => {
      let media = new Media(fr.result)
      media.attachable_id = this.order.id
      media.attachable_type = 'App\\Models\\Order'
      try {
        media = await media.save()
        const content = {
          text: 'Upload รูปส่งของ',
          attachments: [
            media
          ]
        }
        this.doPostComment(TimelineConst.TYPE_ATTACH, JSON.stringify(content))

        media.thumbnail = media.content
        this.order.medias.push(media)
        this.$root.$emit('onSuccess', {message: 'อัพโหลดรูปสำเร็จ'})
      } catch (e) {
        this.$root.$emit('onError', {error: e})
      }

      //var address = clone(this.selectedObject)
      // debugger
    })
  }

};

</script>
